
// // 项目
interface Item {
  itemName?: string;
  itemList?: Category[];
}
// 分类
interface Category {
  categoryName?: string;
  categoryList: CategoryDetail[];
}
// 分类详情
interface CategoryDetail {
  detailName?: string;
  detailDesc?: string;
}
import { defineComponent, PropType } from "vue";
export default defineComponent({
  name: "CardFieldStandard",
  props: {
    list: {
      type: Array as PropType<Item[]>,
      default: () => []
    }
  }
});
